import ApolloClient from 'apollo-boost';

export default new ApolloClient({
  uri: 'https://fakerql.com/graphql',
});
